import React, { useEffect, useMemo, useState } from "react";
import { BusinessPartner, MarketersAnalysis } from "../../pages";
import { MarketersController } from "../../controllers";
import { object, string } from "yup";
import { toJS } from "mobx";
import { marketersStore } from "../../stores";

const BusinessPartnerContainer = ({
  businessPartner,
  setItem,
  setTodoModal,
  setTradingName,
  filterParams,
}) => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const businessPartnerTableQuery = useMemo(() => {
    let query = `offset=${currentPage + 1}&limit=${limit}&type=businessPartner`;
    // if (businessPartner) {
    //   query += `&businessPartner=${businessPartner}`;
    // }
    if (filterParams) {
      query += `&businessPartner=${filterParams}`;
    }
    return query;
  }, [currentPage, limit, filterParams]);

  const { isLoading, data, isFetching } =
    MarketersController.useGetBusinessPartnersBusinesses(
      businessPartnerTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  return (
    <BusinessPartner
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      marketerAnalysis={toJS(marketersStore.marketerAnalysis)}
      setItem={setItem}
      setTodoModal={setTodoModal}
      setTradingName={setTradingName}
    />
  );
};

export default BusinessPartnerContainer;
